export enum UomSelectorTypes {
  SelectedDimension = '[UoM] Selected Dimension',
}
